import API from "../../Api";
import {
  AddFavRestaurants,
  LocationDetails,
  UpdateUserDetailsPayload,
  UserGivenDetail,
} from "./userModels";
import { encryptJson } from "../../utils/react-ec-utils";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_ID } from "../../constants";
var axios = require("axios");

export function getUserDetails() {
  const userID = getCookie(USER_ID)
  const encryptedData = encryptJson({customerId:userID});
  return (
    userID &&
    API({
      method: "post",
      url: `/api/customers/user/profile`,
      data: {"data":encryptedData}
    })
  );
}

export function updateLocationDetails(data: LocationDetails) {
  const userID = getCookie(USER_ID)
  const encryptedData = encryptJson({customerLocation:data});
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    data: {"data":encryptedData}
  });
}
export function deleteLocation(data: LocationDetails) {
  const userID = getCookie(USER_ID)
  const encryptedData = encryptJson({customerLocation:data});
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    data: {"data":encryptedData}
  });
}

export function addFavRestaurant(data: AddFavRestaurants) {
  const userID = getCookie(USER_ID)
  const encryptedData = encryptJson({customerId:userID,favoriteMerchantLocationRequest:data});
  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    data:{'data':encryptedData}
  });
}
export function updateUserProfile() {
  return API({
    method: "put",
    url: "/customer/88e97221-feb5-4b35-a615-2f74a2132121/profile",
  });
}

export function updateEmail(email: string) {
  const userID = getCookie(USER_ID)
  const encryptedData = encryptJson({email:email});

  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    data: {'data':encryptedData},
  });
}

// For Promo Subscribed

export function promoConsent(promo: number) {
  const encryptedData = encryptJson({isPromoSubscribed:promo});

  return API({
    method: "put",
    url: `/api/customers/user/profile`,
    data: encryptedData,
  });
}

// Update user details
export function updateUserDetails(data: UpdateUserDetailsPayload) {
  const encryptedData = 
  encryptJson(
    data
);

  return API({
    method: "put",
    url: `/api/customers/user/update`,
   data: { data : encryptedData },
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
